export const loadLocalStorageSettings = (): string | null => {
    const settings = localStorage.getItem('app-settings');
    return settings ? JSON.parse(settings) : settings;
}